import { computed } from "vue";
import { doc } from "firebase/firestore";
import { useCurrentUser, useDocument, useFirestore } from "vuefire";

export function useBankProgress(bank) {
  const db = useFirestore();
  const user = useCurrentUser();
  const progress = useDocument(
    computed(() =>
      user.value?.uid && bank.value
        ? doc(db, "users", user.value.uid, "bankProgress", bank.value)
        : null,
    ),
  );
  return progress;
}
